import { GameConstants } from "./../../GameConstants";
import { BoardContainer } from "./board-container/BoardContainer";
import { BoardScene } from "./BoardScene";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class BoardManager {

    public static init(): void {
        
        GameVars.paused = true;
    }

    public static startGame(difficulty: string): void {

        GameVars.difficulty = difficulty;
        GameVars.currentTurn = 0;
        GameVars.firstTurn = 0;
        GameVars.topCardDeck = 51;
        GameVars.numPlayers = 4;
        GameVars.removePlayer = -1;
        GameVars.roundBonus = 0;
        GameVars.tutorialCount = 0;
        GameVars.gameOver = false;

        BoardManager.startPlayers();

        BoardScene.currentInstance.startGame();
    }

    public static dealCards(): void {

        GameVars.needStop = -1;
        GameVars.topCardDeck = 51;
        GameVars.round = 0;
        GameVars.cards = Phaser.Utils.Array.Shuffle(GameVars.cards);

        for (let j = 0; j < 4; j++) {
            GameVars.players[j].cards = [];
        }

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < 4; j++) {
                if (GameVars.players[j].tokens > 0) {
                    let cardValue = GameVars.cards[GameVars.topCardDeck];
                    GameVars.players[j].cards.push(cardValue);

                    GameVars.topCardDeck--;
                }
            }
        }
    }

    public static nextTurn(upgradeTurn: boolean): void {

        if (upgradeTurn) {
            GameVars.currentTurn++;
        }

        if (GameVars.currentTurn === 4) {
            GameVars.currentTurn = 0;
        }

        while (GameVars.players[GameVars.currentTurn].tokens === 0) {

            GameVars.currentTurn++;

            if (GameVars.currentTurn === 4) {
                GameVars.currentTurn = 0;
            }
        }

        if (GameVars.currentTurn === GameVars.firstTurn) {
            GameVars.round++;
        }

        if (GameVars.needStop === GameVars.currentTurn) {
            BoardContainer.currentInstance.moveBusToStop();
            BoardManager.decideWinner();
            BoardContainer.currentInstance.showScores();
            return;
        }

        BoardContainer.currentInstance.nextTurn();
    }

    public static decideWinner(): void {

        // calculate player points 

        for (let i = 0; i < GameVars.players.length; i++) {

            if (GameVars.players[i].tokens === 0) {
                continue;
            }

            // caso 3 of a kind
            if (GameVars.players[i].cards[0].value === GameVars.players[i].cards[1].value && GameVars.players[i].cards[0].value === GameVars.players[i].cards[2].value) {
                GameVars.players[i].result.points = 30;
                GameVars.players[i].result.suit = 4;
                continue;
            }

            let result1 = {points: BoardManager.valueToNumber(GameVars.players[i].cards[0].value), suit: GameVars.players[i].cards[0].suit};
            let result2 = {points: 0, suit: -1};
            let result3 = {points: 0, suit: -1};

            if (GameVars.players[i].cards[1].suit === result1.suit) {
                result1.points += BoardManager.valueToNumber(GameVars.players[i].cards[1].value);
            } else {
                result2 = {points: BoardManager.valueToNumber(GameVars.players[i].cards[1].value), suit: GameVars.players[i].cards[1].suit};
            }

            if (GameVars.players[i].cards[2].suit === result1.suit) {
                result1.points += BoardManager.valueToNumber(GameVars.players[i].cards[2].value);
            } else if (GameVars.players[i].cards[2].suit === result2.suit) {
                result2.points += BoardManager.valueToNumber(GameVars.players[i].cards[2].value);
            } else {
                result3 = {points: BoardManager.valueToNumber(GameVars.players[i].cards[2].value), suit: GameVars.players[i].cards[2].suit};
            }

            let points = result1.points;
            let suit = result1.suit;

            if (result2.points > points) {
                points = result2.points;
                suit = result2.suit;
            }

            if (result3.points > points) {
                points = result3.points;
                suit = result3.suit;
            }

            GameVars.players[i].result.points = points;
            GameVars.players[i].result.suit = suit;
        }

        // calculate positions

        let results = [];

        for (let i = 0; i < GameVars.players.length; i++) {

            if (GameVars.players[i].tokens === 0) {
                continue;
            }

            results.push({id: i, points: GameVars.players[i].result.points, pos: 0});
        }

        results.sort((a, b) => (a.points > b.points) ? -1 : 1);

        for (let i = 0; i < results.length; i++) {

            results[i].pos = i + 1;

            if (i !== 0 && results[i].points === results[i - 1].points) {
                results[i].pos = results[i - 1].pos;
            }
        }

        GameVars.lastPosition = results[results.length - 1].pos;
        GameVars.currentTurn = results[0].id;
        GameVars.firstTurn = results[0].id;

        for (let i = 0; i < results.length; i++) {
            GameVars.players[results[i].id].position = results[i].pos; 
        }

        // tokens and points

        let numLast = 0;

        for (let i = 0; i < results.length; i++) {
            if (results[i].pos === GameVars.lastPosition) {
                numLast++;
            }
        }

        for (let i = 0; i < results.length; i++) {
            let points = (4 - results[i].pos) * 200 + GameVars.players[results[i].id].result.points * 10;
            GameVars.players[results[i].id].lastPoints = points;
            GameVars.players[results[i].id].points += points;
        }

        if (numLast === 1) {
            GameVars.players[results[results.length - 1].id].tokens--;
            GameVars.players[results[results.length - 1].id].lastPoints = 0;

            if (GameVars.players[results[results.length - 1].id].tokens === 0) {
                GameVars.removePlayer = results[results.length - 1].id;
            }

            let points = (4 - results[results.length - 1].pos) * 200 + GameVars.players[results[results.length - 1].id].result.points * 10;
            GameVars.players[results[results.length - 1].id].points -= points;
        }

        if (GameVars.players[0].position === 1) {
            GameVars.roundBonus += 1000;
        }
    }

    public static cardToWaste(): void {

        GameVars.topCardWaste = GameVars.cards[GameVars.topCardDeck];
        GameVars.topCardDeck--;
    }

    public static allCardsToDeck(): void {

        BoardContainer.currentInstance.allCardsToDeck();
    }

    public static deckCardToPlayer(): void {
        
        let cardValue = GameVars.cards[GameVars.topCardDeck];
        GameVars.players[GameVars.currentTurn].cards.push(cardValue);

        GameVars.topCardDeck--;

        BoardContainer.currentInstance.deckContainer.dealCard(GameVars.currentTurn, 3, false);

        if (GameVars.currentTurn === 0) {
            BoardManager.activeInputPlayerCards();
        } else {
            BoardManager.selectAdversaryCardToWaste();
        }
        
    }

    public static wasteCardToPlayer(): void {
        
        GameVars.players[GameVars.currentTurn].cards.push(GameVars.topCardWaste);

        BoardContainer.currentInstance.deckContainer.dealCard(GameVars.currentTurn, 3, false, GameVars.currentTurn !== 0);

        if (GameVars.currentTurn === 0) {
            BoardManager.activeInputPlayerCards();
        } else {
            BoardManager.selectAdversaryCardToWaste();
        }
    }

    public static activeInputPlayerCards(): void {

        BoardContainer.currentInstance.deckContainer.enableInputPlayerCards();
    }

    public static playerCardToWastePile(cardValue: CardValue): void {

        if (GameVars.currentTurn === 0) {
            BoardContainer.currentInstance.deckContainer.disableInputPlayerCards();
            BoardContainer.currentInstance.playerContainer.hideStop();
        }

        GameVars.topCardWaste = cardValue;

        GameVars.players[GameVars.currentTurn].cards.splice(GameVars.players[GameVars.currentTurn].cards.indexOf(cardValue), 1);

        BoardContainer.currentInstance.deckContainer.cardPlayerToWaste();

        GameVars.currentScene.time.addEvent({ delay: 150, callback: () => {
            for (let i = 0; i < GameVars.players[GameVars.currentTurn].cards.length; i++) {
                BoardContainer.currentInstance.deckContainer.dealCard(GameVars.currentTurn, i, false);
            }
        }, callbackScope: GameVars.currentScene});
        
    }

    public static selectAdversaryCard(): void {

        let  str = BoardContainer.currentInstance.selectDeckOrWasteAI();

        GameVars.currentScene.time.addEvent({ delay: 500, callback: () => {
            if (str === "deck") {
                BoardManager.deckCardToPlayer();
            } else {
                BoardManager.wasteCardToPlayer();
                BoardContainer.currentInstance.addCardToPlayerAI();
            }  
        }, callbackScope: GameVars.currentScene});

    }

    public static selectAdversaryCardToWaste(): void {

        let result = BoardContainer.currentInstance.selectCardAndStopAI();
        let audioStop = false;

        if (result.stop && GameVars.round > 1 && GameVars.needStop === -1) {
            GameVars.needStop = GameVars.currentTurn;
            audioStop = true;
        }

        BoardContainer.currentInstance.removeCardToPlayerAI(GameVars.players[GameVars.currentTurn].cards[result.card]);

        GameVars.currentScene.time.addEvent({ delay: 1000, callback: () => {
            BoardManager.playerCardToWastePile(GameVars.players[GameVars.currentTurn].cards[result.card]);
            if  (audioStop) {
                AudioManager.playSound("stop_the_bus_bell");
            }
        }, callbackScope: GameVars.currentScene});

    }

    private static startPlayers(): void {

        GameVars.players = [];

        let ids = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        let maleNames = ["Oliver", "Harry", "George", "Noah", "Jack", "Jacob", "Leo", "Oscar", "Charlie", "David", "Enrique", "Javi"];
        let femaleNames = ["Olivia", "Amelia", "Isla", "Ava", "Emily", "Isabella", "Mia", "Poppy", "Ella", "Lily", "Ania", "Lisa"];

        for (let i = 0; i < 4; i++ ) {

            
            let id = i === 0 ? GameVars.gameData.id : ids[Math.floor(Math.random() * ids.length)];
            ids.splice(ids.indexOf(id), 1);
            let genre = i === 0 ? GameVars.gameData.genre : (Math.random() > .5 ? GameConstants.GENDER_FEMALE : GameConstants.GENDER_MALE);
            let name = i === 0 ? "You" : (genre === GameConstants.GENDER_FEMALE ? femaleNames[id - 1] : maleNames[id - 1]);

            let playerInfo: PlayerInfo = {
                cards: [],
                points: 0,
                tokens: 3,
                avatarId: id,
                gender: genre,
                name: name,
                result: {points: 0, suit: -1},
                position: 0,
                lastPoints: 0
            };

            GameVars.players.push(playerInfo);
        }
    }

    private static valueToNumber(value: string): number {

        if (value === "A") {
            return 11;
        } else if (value === "J" || value === "Q" || value === "K") {
            return 10;
        } else {
            return parseInt(value);
        }
    }
}